<template>
  <div class="content-box">
    <Loader v-if="loading" />
    <div class="full-chat-w" v-else>
      <div class="full-chat-i">
        <div class="full-chat-left scrollable">
          <div class="ae-list-w">
            <div class="ael-head">
              <div class="actions-left">
                <h5>{{ pendingProducts.length }} Products</h5>
                <!-- <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString"  placeholder="Type to filter..." type="search"></div> -->
              </div>
              <div class="actions-right">
                <div class="btn-group">
                  <button
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                    style="padding-left: 0; background: #f2f4f8;"
                  >
                    <h6 class="dispatch-location">Bulk Action</h6>
                  </button>
                  <div
                    aria-labelledby="export-button"
                    class="dropdown-menu"
                    x-placement="top-start"
                  >
                    <a
                      class="dropdown-item"
                      @click="actionPendingProductBulk(1)"
                      >Approve All</a
                    >
                    <a
                      class="dropdown-item"
                      @click="actionPendingProductBulk(0)"
                      >Reject All</a
                    >
                  </div>
                </div>
                <a @click="refreshProductRail"
                  ><i class="os-icon os-icon-grid-18"></i
                ></a>
              </div>
            </div>
            <div class="ael-head">
              <div class="actions-left">
                <h5>Sort By</h5>
                <!-- <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString"  placeholder="Type to filter..." type="search"></div> -->
              </div>
              <div class="actions-right">
                <div class="btn-group">
                  <button
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                    style="padding-left: 0; background: #f2f4f8;"
                  >
                    <h6 class="dispatch-location">{{sort_order}}</h6>
                  </button>
                  <div
                    aria-labelledby="export-button"
                    class="dropdown-menu"
                    x-placement="top-start"
                  >
                    <a
                      class="dropdown-item"
                      @click="changeSort('ASC')"
                      >Oldest First</a
                    >
                    <a
                      class="dropdown-item"
                      @click="changeSort('DESC')"
                      >Newest First</a
                    >
                  </div>
                </div>
                <a
                  ><i class="fa fa-sort"></i
                ></a>
              </div>
            </div>
            <div class="ae-list">
              <Loader v-if="loadingPendingRail" />
              <ProductRail
                :products="pendingProducts"
                :selectedProduct="selectedProduct"
                @productRailInterface="updateSelectedProduct"
                v-else
              />
            </div>
          </div>
        </div>
        <div class="full-chat-middle">
          <div class="chat-head">
            <div class="user-info">
              <button
                class="mr-2 mb-2 btn btn-success btn-sm large-button"
                type="button"
                @click="updateFinalSequence"
                v-if="sequenceUpdateRequired == true"
              >
                Update Sequence
              </button>
              <div
                v-show="
                  loadingImages == false &&
                    waitingForAction == false &&
                    sequenceUpdateRequired == false
                "
              >
                <button
                  class="mr-2 mb-2 btn btn-success btn-sm"
                  type="button"
                  @click="actionPendingProduct(1)"
                >
                  Approve
                </button>
                <button
                  class="mr-2 mb-2 btn btn-danger btn-sm"
                  type="button"
                  @click="actionPendingProduct(0)"
                >
                  Reject
                </button>
                <button
                  class="mr-2 mb-2 btn btn-danger btn-sm"
                  type="button"
                  @click="holdProduct(0)"
                >
                  Reject and Hold
                </button>
              </div>
            </div>
            <div class="user-actions">
              <a>
                <i
                  class="fas fa-spinner fa-spin"
                  v-if="resequencingImages == 'pending'"
                ></i>
                <i
                  class="fas qc-1 fa-check"
                  v-if="resequencingImages == 'done'"
                ></i>
              </a>
            </div>
          </div>
          <div class="chat-content-w">
            <EmptyState v-if="waitingForAction">
              <div slot="empty_state_text" v-if="pendingProducts.length > 0">
                Select a product to continue
              </div>
              <div slot="empty_state_text" v-else>
                There are no products in queue
              </div>
            </EmptyState>
            <div v-else>
              <Loader v-if="loadingImages" />
              <Workspace
                :product="selectedProduct"
                :final-images="finalImages"
                :images="images"
                :type="'retouch'"
                @resequenceInterface="resequenceImages"
                v-else
              />
            </div>
          </div>
          <div class="chat-controls" v-if="!waitingForAction">
            <div class="chat-input">
                <textarea
                  class="form-group form-control"
                  placeholder="Type your comment..."
                  type="text"
                  contenteditable
                  v-model="productComment"
                />
            </div>
            <div class="chat-input-extra">
              <div class="chat-extra-actions">
                <a>
                  <i class="os-icon os-icon-mail-07"></i>
                </a>
              </div>
              <div class="chat-btn">
                <a class="btn btn-primary btn-sm" @click="addProductComment"
                  >Add Comment</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="full-chat-right scrollable">
          <EmptyState v-if="waitingForAction || loadingProduct">
            <div slot="empty_state_text">
              ..
            </div>
          </EmptyState>
          <ProductInfoBlock
            :selectedProduct="selectedProduct"
            :finalImages="finalImages"
            :type="'retouchdesk'"
            v-else
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Placeholder from '@/components/common/Placeholder'
import EmptyState from '@/components/common/EmptyState'
import Workspace from '@/components/photodesk/Workspace'
import ProductRail from '@/components/common/SessionAdd/ProductRail'
import ProductInfoBlock from '@/components/common/SessionAdd/ProductInfoBlock'

import Session from '@/mixins/session'
import Product from '@/mixins/product'

import At from 'vue-at'
import AtTa from 'vue-at/dist/vue-at-textarea'
import { debounce } from 'underscore'

export default {
  name: 'session-view',
  mixins: [Session, Product],
  components: {
    Loader,
    EmptyState,
    Workspace,
    ProductRail,
    ProductInfoBlock,
    Placeholder,
    At,
    AtTa
  },
  props: ['id_session'],
  data: function () {
    return {
      session: '',
      pendingProducts: [],
      selectedProduct: '',
      images: [],
      finalImages: [],
      allocatedImages: [],
      loading: true,
      loadingImages: false,
      loadingProduct: false,
      loadingPendingRail: true,
      waitingForAction: true,
      resequencingImages: '',
      productComment: '',
      sort_order: 'Oldest First',
      sort: 'ASC'
    }
  },
  mounted: function () {
    this.getSessionDetails()
  },
  methods: {
    changeSort: function(sort) {
      this.sort = sort
      this.sort_order = this.sort == 'DESC' ? 'Newest First' : 'Oldest First';
      this.refreshProductRail()

    },
    getSessionDetails: function () {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      const url = '/retouchdesk/sessions/view'
      let data = {
        id_retouchdesk_session: self.id_session
      }
      self.loading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.session = response.data
          self.getPendingProducts()
          self.loading = false
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.response,
            show: true
          })
          self.loading = false
        })
    },
    getPendingProducts: function () {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      const url = '/retouchdesk/sessions/products/pending'
      let data = {
        id_retouchdesk_session: self.session.id_retouchdesk_session,
        sort: this.sort
      }
      self.loadingPendingRail = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pendingProducts = response.data
          self.loadingPendingRail = false
        })
        .catch(function (error) {
          // add toast message
          self.$store.dispatch('updateToast', {
            text: error.response,
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    actionPendingProductBulk: function (action) {
      const actionText = action == 1 ? 'approve ' : 'reject '
      const productsLength = this.pendingProducts.length

      if (!confirm('Are you sure you want to ' + actionText + productsLength + ' products?')) {
        console.log(this.pendingProducts[0])
        return
      }
      var self = this
      const url = '/retouchdesk/sessions/products/add'

      let id_products = self.pendingProducts.map(function (product, index, array) {
        return product.id_product
      })

      let data = {
        id_retouchdesk_session: self.session.id_retouchdesk_session,
        id_product: id_products.toString(),
        is_approve: action
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (action == 1) {
            self.$store.dispatch('updateToast', {
              text: productsLength + ' Products Approved',
              show: true
            })
          } else {
            self.$store.dispatch('updateToast', {
              text: productsLength + ' Products Rejected',
              show: true
            })
          }
          self.refreshProductRail()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.response,
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    actionPendingProduct: function (action) {
      var self = this
      const url = '/retouchdesk/sessions/products/add'
      const id_products = []

      id_products.push(self.selectedProduct.id_product)

      let data = {
        id_retouchdesk_session: self.session.id_retouchdesk_session,
        id_product: id_products.toString(),
        is_approve: action
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (action == 1) {
            self.$store.dispatch('updateToast', {
              text: 'Product Approved',
              show: true
            })
          } else {
            self.$store.dispatch('updateToast', {
              text: 'Product Rejected',
              show: true
            })
          }
          self.loadNextProduct()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.response,
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    holdProduct: function (action) {

      let folder = prompt('Folder name where you want to hold this product?');

      if (!folder) {
        alert('A folder name is required')
        return
      }

      var self = this
      const url = '/retouchdesk/sessions/products/add'
      const id_products = []

      id_products.push(self.selectedProduct.id_product)

      let data = {
        id_retouchdesk_session: self.session.id_retouchdesk_session,
        id_product: id_products.toString(),
        is_approve: action,
        hold_folder: folder
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (action == 1) {
            self.$store.dispatch('updateToast', {
              text: 'Product Approved',
              show: true
            })
          } else {
            self.$store.dispatch('updateToast', {
              text: 'Product Rejected',
              show: true
            })
          }
          self.loadNextProduct()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.response,
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    loadNextProduct: function () {
      var self = this;
      var current_ix = self.selectedProduct.id_photodesk_product
      
      var next_product = current_ix

      self.pendingProducts.find((o, i) => {
        if (o.id_photodesk_product > current_ix) {
          next_product = i
          return true;
        }
      });

      self.pendingProducts.find((o, i) => {
        if (o.id_product == self.selectedProduct.id_product) {
          self.pendingProducts.splice(i, 1);
          return true;
        }
      });
      if (self.pendingProducts.length > 0) {
        self.selectedProduct = this.pendingProducts[next_product - 1];
        self.waitingForAction = true;
        self.updateSelectedProduct(self.selectedProduct);
      } else {
        self.selectedProduct = "";
        self.waitingForAction = true;
      }
    },
    refreshProductRail: function () {
      this.getPendingProducts()
      this.selectedProduct = ''
      this.waitingForAction = true
    },
    updateSelectedProduct: function (data) {
      this.selectedProduct = data
      this.getProduct()
      this.waitingForAction = false
    },

    resequenceImages: function (data) {
      var self = this
      if (data == 'start') {
        self.resequencingImages = 'pending'
      } else {
        self.resequencingImages = 'done'
        setTimeout(function () {
          self.resequencingImages = ''
        }, 2000)
      }
    },

    addProductComment: function () {
      var self = this
      const url = '/productdesk/product/comment/add'
      let data = {
        id_product: self.selectedProduct.id_product,
        comment: self.productComment
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.productComment = ''
          self.getProductComments()
          console.log(response)
        })
        .catch(function (error) {})
    }
  },
  computed: {
    clientUsers () {
      return this.$store.getters.clientUsers
    },
    searchString: debounce(function () {
      this.isTyping = false
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.getSessionDetails()
      }
    }
  }
}
</script>

<style scoped>
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}
.ae-list-w {
  background-color: #f2f4f8;
}
.element-wrapper .element-search input {
  background-color: #fff;
  border-radius: 0px !important;
}

.full-chat-w .full-chat-left {
  padding: 0px !important;
}

.element-wrapper {
  padding-bottom: 0rem !important;
}

.os-tab {
  position: absolute;
  top: 0;
  width: 340px;
  background: #f2f4f8;
  z-index: 999;
}

.tab-container {
  margin-top: 53px;
}
.dispatch-location {
  padding-top: 6px;
}
</style>
